import React from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Modal from "../component3/Modal";
import DGCEO from "./dg-ceo-sm.jpg"
import DGCEOPLACEHOLDER from "./dg-ceo-sm-placeholder.jpg"
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css"
import Typography from "@mui/material/Typography";
import PlaceIcon from '@mui/icons-material/Place';

export default function HomeFromDgCeo(){
    return<Stack
    alignItems="center"
    direction={{ xs: "column-reverse", md: "row" }}
    sx={{
      p: 2,
      // pb: 4,
      display: "flex",
      justifyContent: "space-around",
      bgcolor: "rgba(212, 211, 211,0.3)",
      // background: "rgb(222,223,236)",
      background:
        "linear-gradient(90deg, rgba(222,223,236,0.2) 21%, rgba(1,5,23,0.3) 49%, rgba(0,72,102,0.9962359943977591) 82%)",
      borderTopRightRadius: 30,
      borderTopLeftRadius: 30,
    }}
  >
    <Box
      sx={{
        maxWidth: 500,
      }}
    >
      <Box sx={{ fontSize: 36, fontFamily: "roboto" }}>
        From the <span style={{ color: "gold" }}>DG/CEO's</span> Desk
      </Box>
      {/* text-gray-600 */}
      <p
        className="font-normal text-base leading-6 mt-6 xs:p-3 sm:p-3"
        style={{ fontFamily: "Open Sans" }}
      >
        
              <Typography gutterBottom variant="h6">
                New Strategic Goals of NACETEM
              </Typography>
              <Typography variant="body2">
                <ul>
                  <li style={{marginBottom:5}}>
                    <PlaceIcon/> Strengthen capacity building services of the Agency.
                  </li>
                  <li style={{marginBottom:5}}>
                    <PlaceIcon/> Digitize all operational activities and services of the
                    Agency(E-NACETEM).
                  </li>
                  <li style={{marginBottom:5}}>
                    <PlaceIcon/> FCSSIP25 implementation for reformation of the Agency.
                  </li>
                  <li style={{marginBottom:5}}><PlaceIcon/> Create new STEM education programs.</li>
                  <li style={{marginBottom:5}}><PlaceIcon/> Certification programs for tech-artisans.</li>
                  <li style={{marginBottom:5}}>
                    <PlaceIcon/> Technology infusion programs to all sectors of the
                    national economy
                  </li>
                  <li style={{marginBottom:5}}><PlaceIcon/> STI management researches & policy evaluations.</li>
                  <li style={{marginBottom:5}}>
                    <PlaceIcon/> Institution of an annual high-level technology innovation
                    policy dialogue.
                  </li>
                  <li style={{marginBottom:5}}>
                    <PlaceIcon/> Introduction of the NACETEM Academy to manage educational
                    services provided by NACETEM.
                  </li>
                  <li style={{marginBottom:5}}>
                  <PlaceIcon/> Building capacities and professionalism of NACETEM staff.
                  </li>
                </ul>
              </Typography>
              <Typography variant="h6">
                Dr. Olusola Odusanya NACETEM DG/CEO
              </Typography>
            
        {/* Advances in science and technology are being recorded at a dizzying
        speed in our world today, and with the pivotal role of technology in
        development, there is an increasing need for technology management.
        Technology management entails planning, development, use and
        diffusion of technology as well as its application to the industry
        and its impacts on the social, economic, cultural, political and
        geographical environment of a nation.
        <br />
        <Modal
          title="From the DG/CEO Desk"
          displayText="Read More"
          bodyText={
            <span>
              &nbsp; Any firm, industry or nation that places a premium on
              technology management sets itself up for rapid growth and
              development. With our nation's current drive to be a major
              player in the global economy due to its human and natural
              endowments, as well as the country's commitment to the 2030
              Agenda for Sustainable Development, the need for an aggressive
              approach towards science and technology-driven development is
              more urgent than before. This urgency is what makes NACETEM
              critical to Nigeria's development through science and
              technology. To this end, NACETEM has developed several
              cutting-edge programmes anchored on the tripod of capacity
              building, policy research and consultancy in the areas of
              Science, Technology and Innovation (STI) management. We
              therefore invite you to carefully go through this information
              brochure to avail yourself of what we do and how we do it as a
              knowledge support institution with a view to benefiting from
              our wealth of experience in STI management for sustainable
              development.
            </span>
          }
        /> */}
      </p>
    </Box>
    <Box>
     <img src="/dg-ceo-sm.jpg"  width="100%"/>
    </Box>
    {/* <Box>
      <LazyLoadImage 
        src={DGCEO}
        width="100%"
        Placeholder={DGCEOPLACEHOLDER}
        effect="blur"   
        /> 
    </Box> */}
  </Stack>
}